// extracted by mini-css-extract-plugin
export default {"hidescrollbar":"EmployeeDashboardMessage_hidescrollbar__YY6vZ","input":"EmployeeDashboardMessage_input__ZsR0X","customBadge":"EmployeeDashboardMessage_customBadge__NBOhR"};